import { lighten } from "@material-ui/core/styles/colorManipulator";

export const styles = (theme) => ({
  tableCellInCollapes: {
    borderBottom: "none",
  },
  paperWidthSm: {
    width: "50%",
    maxWidth: "unset",
  },
  rootInputLabel: {
    fontSize: "1rem",
  },
  root: {
    minHeight: "2rem",
  },
  wrapGrid: {
    width: "100%",
  },
  // root: {
  //   width: '100%',
  //   backgroundColor: theme.palette.background.paper,
  //   paddingBottom: 0,
  // },
  titleContainer: {
    marginBottom: theme.spacing(3),
  },
  table: {
    // minWidth: 1020,
  },
  btnActionColumn: {
    margin: theme.spacing(0.5),
  },
  actionColumn: {
    margin: -theme.spacing(0.5),
  },
  chips: {
    margin: -theme.spacing(1),
  },
  chip: {
    margin: theme.spacing(1),
  },
  tableWrapper: {
    overflowX: "auto",
  },
  body: {
    lineHeight: "1.3rem",
    fontSize: "1rem",
    cursor: "pointer",
  },
  body_limit: {
    lineHeight: "1.3rem",
    maxWidth: "10rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "1rem",
    cursor: "pointer",
  },
  button_addFeatured: {
    cursor: "pointer",
    // color: '#3f98ff',
    textTransform: "capitalize",
  },
  button_removeFeatured: {
    cursor: "pointer",
    color: "#757582",
    textTransform: "capitalize",
  },
  tableCellEdit: {
    borderBottom: "none",
  },
  tableRowHeight: {},
  textFieldModal: {
    display: "block",
  },
  TextFieldGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
  },
  title: {
    fontSize: "2rem",
    fontWeight: 500,
    color: "#000000",
    padding: 0,
    textAlign: "center",
    marginTop: "3.268%",
    lineHeight: "normal",
    "@media only screen and (min-width:800.98px) and (max-width:1679.98px)": {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
      lineHeight: "normal",
    },

    "@media only screen and (min-width:958.98px) and (max-width:1024px) ": {
      fontSize: "1.25rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      fontSize: "1.125rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
  },
  inputModal: {
    width: "500px",
  },
  paper: {
    position: "absolute",
    // width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  buttonModal: {
    margin: -theme.spacing(1),
    textAlign: "right",
  },
  button: {
    minWidth: "max-content",
  },
  buttonOnEdit: {
    margin: "8px",
  },
  contentAddForm: {
    backgroundColor: "#ffffff",
    height: "100%",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  inputType: {
    height: "unset",
  },
  customFilterInput: {
    minWidth: "136px",
    height: "2.3rem",
    marginRight: "1rem",
  },
});

export const editMenuItemStyles = (theme) => ({
  inputType: {
    height: "unset",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  textField: {
    width: "100%",
  },
  menu: {
    width: "15%",
  },
  label: {
    fontWeight: 410,
  },
  actives: {
    fontSize: 16,

    marginLeft: "60px",
    display: "inline-block",
  },
  button: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  switchBase: {
    "&$switchChecked": {
      color: theme.palette.common.white,
      "& + $switchBar": {
        backgroundColor: "#52d869",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  switchChecked: {
    transform: "translateX(15px)",
    "& + $switchBar": {
      opacity: 1,
      border: "none",
    },
  },
  switchBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  switchIcon: {
    width: 24,
    height: 24,
  },
  switchIconChecked: {
    boxShadow: theme.shadows[1],
  },
  containerImageRound: {
    position: "relative",
    borderRadius: "50%",
    margin: "auto",
    width: "9rem",
    height: "9rem",
    // border: '2px solid #F2F2F2',
    // boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  camera: {
    top: 0,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "2rem",
    height: "2rem",
    marginTop: "75%",
    marginLeft: "75%",
    border: "4px solid #fff",
    backgroundColor: " #ff513f",
    borderRadius: "50%",
  },
  iconCamera: {
    width: "1.3rem",
  },
  flexGroup: {
    display: "flex",
    alignItems: "center",
  },
});

export const tablecellStyles = (theme) => ({
  head: {
    textTransform: "capitalize",
    whiteSpace: "nowrap",
  },
});

export const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  textField: {
    width: "20%",
    float: "right",
  },
  icon: {
    marginTop: theme.spacing(3),
    width: 36,
    height: 36,
    left: -8,
  },
  // modify
  toolbarContainer: {
    height: "12%",
  },
});
